module.exports = {"system_events":"Eventos internos del sistema"}


//////////////////
// WEBPACK FOOTER
// ./src/translates/es/Events.json
// module id = 601
// module chunks = 1